"use strict";
'use es6'; // pared down from
// https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/debounceCore.js

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(fn, wait, context) {
  var timeout;

  function debouncer() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    debouncer.reset();

    var callback = function callback() {
      fn.apply(context, args);
    };

    timeout = setTimeout(callback, wait);
  }

  debouncer.reset = function () {
    clearTimeout(timeout);
  };

  return debouncer;
};

exports.default = _default;
module.exports = exports.default;